export function tableToExcel(tableId, worksheetName, fileName, preTableRows = [], columnWidths = []) {
  new TableToExcel({ tableId, worksheetName, fileName, preTableRows, columnWidths }).toExcel();
}

export function rmFile(id) {
  const rmInput = document.getElementById('rmFiles-input');
  if (confirm('Вы уверены, что хотите удалить этот фаил?')) {
    const fileDisplay = document.getElementById('fileId-' + id);
    fileDisplay.hidden = true;
    if (rmInput.value == '') {
      rmInput.value = id;
    } else {
      rmInput.value += ',' + id;
    }
    console.log(rmInput.value);
  }
}

export class TableToExcel {
  // ссылка на полную документацию по формату Excel 2003 XML Spreadsheet:
  // https://learn.microsoft.com/en-us/previous-versions/office/developer/office-xp/aa140066(v=office.10)?redirectedfrom=MSDN#odc_xmlss_ss:table

  constructor({ tableId, worksheetName, fileName, preTableRows = [], columnWidths = [] }) {
    this.table = document.getElementById(tableId);
    // Очищаем имя листа от недопустимых символов: / \ ? * [ ]
    this.worksheetName = this.sanitizeSheetName(worksheetName || 'Worksheet');
    this.fileName = fileName || 'export.xls';
    this.preTableRows = preTableRows;
    this.columnWidths = columnWidths;
  }

  sanitizeSheetName(name) {
    return String(name).replace(/[\/\\\?\*\[\]]/g, '_');
  }

  toExcel() {
    let tempTable = this.table.cloneNode(true);
    let caption = tempTable.querySelector('caption');
    if (caption) caption.remove();

    let searchRows = tempTable.querySelectorAll('tr.table-search, .d-none');
    searchRows.forEach((row) => row.remove());

    let rows = tempTable.querySelectorAll('tr');

    // Подсчет колонок с учетом colspan
    let colCount = 0;
    rows.forEach(row => {
      let rowColCount = 0;
      let cells = row.querySelectorAll('td, th');
      cells.forEach(cell => {
        let colspan = parseInt(cell.getAttribute('colspan') || '1', 10);
        rowColCount += colspan;
      });
      colCount = Math.max(colCount, rowColCount);
    });

    // Генерируем предтабличные строки
    let preTableXml = this.generatePreTableRows(colCount);
    let preTableRowCount = this.preTableRows.length;

    let rowCount = rows.length + preTableRowCount;

    let xmlRows = '';
    rows.forEach((row) => {
      let hasHeader = row.querySelectorAll('th').length > 0;
      let rowStyle = hasHeader ? ' ss:StyleID="Header"' : '';
      xmlRows += `   <Row${rowStyle}>\n`;

      let cells = row.querySelectorAll('td, th');
      cells.forEach((cell) => {
        let text = cell.textContent.trim();
        let dataType = 'String';

        // Проверка на формулу (начинается с =)
        let formula = null;
        if (text.startsWith('=')) {
          formula = text.substring(1);
          text = '';
        }

        // Очищенный текст без пробелов-разделителей тысяч (обычный, неразрывный, узкий неразрывный)
        let cleanText = text.replace(/[\s\u00A0\u202F]/g, '');
        let numericValue = null;

        if (text !== '' && !formula) {
          // Числа (в т.ч. с пробелами-разделителями тысяч: "9 900")
          if (/^-?\d+\.?\d*$/.test(cleanText) && !isNaN(parseFloat(cleanText)) && isFinite(cleanText)) {
            if (/^\d+$/.test(cleanText) && cleanText.startsWith('0') && cleanText !== '0') {
              dataType = 'String';
            } else {
              dataType = 'Number';
              numericValue = cleanText;
            }
          }
          // Даты в формате YYYY-MM-DD
          else if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
            dataType = 'DateTime';
          }
          // Ошибки Excel
          else if (text.startsWith('#') && ['#NULL!', '#DIV/0!', '#VALUE!', '#REF!',
            '#NAME?', '#NUM!', '#N/A'].includes(text)) {
            dataType = 'Error';
          }
        }

        let cellValue = this.escapeXml(numericValue !== null ? numericValue : text);

        if (text === '' && !formula) {
          xmlRows += `    <Cell/>\n`;
        } else {
          let cellXml = '    <Cell';
          if (formula) {
            cellXml += ` ss:Formula="${this.escapeXml(formula)}"`;
          }
          cellXml += `><Data ss:Type="${dataType}">${cellValue}</Data></Cell>\n`;
          xmlRows += cellXml;
        }
      });
      xmlRows += '   </Row>\n';
    });

    let xmlTemplate = `<?xml version="1.0" encoding="utf-8"?>
    <?mso-application progid="Excel.Sheet"?>
    <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
      xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:x="urn:schemas-microsoft-com:office:excel"
      xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
      xmlns:html="http://www.w3.org/TR/REC-html40">
      <Styles>
        <Style ss:ID="Default" ss:Name="Normal">
          <ss:Font ss:FontName="Arial" ss:Size="10"/>
        </Style>
        <Style ss:ID="Header">
          <ss:Font ss:Bold="1"/>
        </Style>
        <Style ss:ID="Bold">
          <ss:Font ss:FontName="Arial" ss:Size="10" ss:Bold="1"/>
          <ss:Alignment ss:Vertical="Top" ss:WrapText="1"/>
        </Style>
        <Style ss:ID="BoldCenter">
          <ss:Font ss:FontName="Arial" ss:Size="10" ss:Bold="1"/>
          <ss:Alignment ss:Horizontal="Center" ss:Vertical="Top" ss:WrapText="1"/>
        </Style>
        <Style ss:ID="BoldLarge">
          <ss:Font ss:FontName="Arial" ss:Size="14" ss:Bold="1"/>
          <ss:Alignment ss:Vertical="Top" ss:WrapText="1"/>
        </Style>
        <Style ss:ID="BoldLargeCenter">
          <ss:Font ss:FontName="Arial" ss:Size="14" ss:Bold="1"/>
          <ss:Alignment ss:Horizontal="Center" ss:Vertical="Top" ss:WrapText="1"/>
        </Style>
      </Styles>
      <Worksheet ss:Name="${this.escapeXml(this.worksheetName)}">
        <Table ss:ExpandedRowCount="${rowCount}" ss:ExpandedColumnCount="${colCount}" x:FullColumns="1" x:FullRows="1">
          ${this.generateColumnWidths(colCount)}${preTableXml}${xmlRows}    </Table>
      </Worksheet>
    </Workbook>`;

    let blob = new Blob([xmlTemplate], { type: 'application/vnd.ms-excel;charset=utf-8;' });
    let url = window.URL.createObjectURL(blob);
    this.downloadURI(url, this.fileName);
    window.URL.revokeObjectURL(url);
  }

  generateColumnWidths(columnCount) {
    if (!this.columnWidths || this.columnWidths.length === 0) {
      return '';
    }

    let xml = '';
    for (let i = 0; i < columnCount; i++) {
      // Ширина в пунктах (points), по умолчанию 80
      const width = this.columnWidths[i] || 80;
      xml += `      <Column ss:Width="${width}"/>\n`;
    }

    return xml;
  }

  generatePreTableRows(columnCount) {
    if (!this.preTableRows || this.preTableRows.length === 0) {
      return '';
    }

    let xml = '';

    this.preTableRows.forEach((rowData) => {
      // Пустая строка
      if (rowData.empty) {
        xml += '      <Row>\n';
        for (let i = 0; i < columnCount; i++) {
          xml += '        <Cell/>\n';
        }
        xml += '      </Row>\n';
        return;
      }

      // Многоколоночная строка
      if (rowData.cells && Array.isArray(rowData.cells)) {
        // Сортируем ячейки по позиции для гарантии возрастания индексов
        const sortedCells = [...rowData.cells].sort((a, b) => (a.position || 0) - (b.position || 0));

        // Проверяем на перекрытие
        let lastPosition = 0;
        for (let cellData of sortedCells) {
          const position = cellData.position !== undefined ? cellData.position : lastPosition;
          if (position < lastPosition) {
            console.warn('Обнаружено возможное перекрытие ячеек в preTableRows');
          }
          lastPosition = position + (cellData.colspan || 1);
        }

        xml += '      <Row>\n';

        let currentPosition = 0;
        for (let cellData of sortedCells) {
          const position = cellData.position !== undefined ? cellData.position : currentPosition;

          // Если есть разрыв, используем ss:Index для следующей ячейки
          if (position > currentPosition) {
            const style = this.determineStyle(cellData);
            const mergeAcross = (cellData.colspan || 1) - 1;
            const escapedText = this.escapeXml(cellData.text || '');

            xml += `        <Cell ss:Index="${position + 1}"`; // +1 потому что индексы с 1
            if (mergeAcross > 0) {
              xml += ` ss:MergeAcross="${mergeAcross}"`;
            }
            xml += ` ss:StyleID="${style}"><Data ss:Type="String">${escapedText}</Data></Cell>\n`;

            currentPosition = position + (cellData.colspan || 1);
          } else {
            // Обычная вставка без разрыва
            const text = cellData.text || '';
            const colspan = cellData.colspan || 1;

            if (text === '' && !cellData.bold && !cellData.align && !cellData.size) {
              for (let i = 0; i < colspan; i++) {
                xml += '        <Cell/>\n';
              }
            } else {
              const style = this.determineStyle(cellData);
              const mergeAcross = colspan - 1;
              const escapedText = this.escapeXml(text);

              if (mergeAcross > 0) {
                xml += `        <Cell ss:MergeAcross="${mergeAcross}" ss:StyleID="${style}"><Data ss:Type="String">${escapedText}</Data></Cell>\n`;
              } else {
                xml += `        <Cell ss:StyleID="${style}"><Data ss:Type="String">${escapedText}</Data></Cell>\n`;
              }
            }
            currentPosition += colspan;
          }
        }

        xml += '      </Row>\n';
        return;
      }

      // Однострочный текст на все колонки
      if (rowData.text !== undefined) {
        const style = this.determineStyle(rowData);
        const mergeAcross = columnCount - 1;
        const text = this.escapeXml(rowData.text);

        xml += '      <Row>\n';
        xml += `        <Cell ss:MergeAcross="${mergeAcross}" ss:StyleID="${style}"><Data ss:Type="String">${text}</Data></Cell>\n`;
        xml += '      </Row>\n';
      }
    });

    return xml;
  }

  // Объединенный метод определения стиля
  determineStyle(data) {
    if (!data.bold) {
      return 'Default';
    }

    const size = data.size || 10;
    const align = (data.align || '').toLowerCase();

    if (size > 10) {
      if (align === 'center') return 'BoldLargeCenter';
      return 'BoldLarge';
    }

    if (align === 'center') return 'BoldCenter';
    return 'Bold';
  }

  escapeXml(text) {
    if (!text) return '';
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  }

  downloadURI(uri, name) {
    let link = document.createElement('a');
    link.download = name;
    link.href = uri;
    link.click();
  }
}